import { useContext } from 'react';
import { UserRolesAndPermissionsContext } from '../../context/UserRolesAndPermissionsContext';
import { Breadcrumb, Typography } from 'antd';
import { USER_ROLE_KEYS } from '../../utilities/constants';
import { Link, useLocation } from 'react-router-dom';
import { useCompanyManagement } from '../../pages/ExecutiveConsole/components/hooks/useCompanyManagement';

const { Text } = Typography;

const AdminBreadcrumb = () => {
  const { userRole, selectedOrg } = useContext(UserRolesAndPermissionsContext);
  const { orgList } = useCompanyManagement();
  const location = useLocation();
  const path = location.pathname.split('/')[1];

  const breadcrumbItems = [
    {
      title: (
        <Link
          to={
            userRole === USER_ROLE_KEYS.SUPER_ADMIN
              ? '/super-admin-console'
              : '/platform-operations-console'
          }
          key={
            userRole === USER_ROLE_KEYS.SUPER_ADMIN
              ? '/super-admin-console'
              : '/platform-operations-console'
          }
        >
          <Text
            strong
            style={{
              fontSize: 14,
              color: 'var(--button-default-hover-text-color ,#9DC9FF)',
              textDecoration: 'underline',
              textUnderlineOffset: 3,
            }}
          >
            {userRole === USER_ROLE_KEYS.SUPER_ADMIN
              ? 'Super Admin Console'
              : 'Platform Operations Console'}
          </Text>
        </Link>
      ),
    },
    {
      title: (
        <Text
          style={{
            fontSize: 14,
          }}
        >
          {orgList?.find(org => org?.value === selectedOrg)?.label}
        </Text>
      ),
    },
  ];

  return (
    <>
      {(userRole === USER_ROLE_KEYS.SUPER_ADMIN ||
        userRole === USER_ROLE_KEYS.PLATFORM_OPERATION_MANAGER) &&
        path !== 'super-admin-console' &&
        path !== 'platform-operations-console' && (
          <Breadcrumb items={breadcrumbItems} separator=">" />
        )}
    </>
  );
};

export default AdminBreadcrumb;
